module.exports = __webpack_public_path__ + "static/media/DSC04524-2.34a0d945.jpg";